"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../utils/utils");
var _RadioButtonGroup = require("./RadioButtonGroup.styled");
var _RadioButton = _interopRequireDefault(require("./RadioButton"));
var _excluded = ["disabled", "automationId", "onChange", "handleChange", "isLayoutHorizontal", "items", "id", "radioButtonOptions", "selectedItem", "defaultValue", "selectedValue"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var RadioButtonGroup = /*#__PURE__*/_react["default"].forwardRef(function RadioButtonGroup(_ref, ref) {
  var disabled = _ref.disabled,
    automationId = _ref.automationId,
    _onChange = _ref.onChange,
    handleChange = _ref.handleChange,
    isLayoutHorizontal = _ref.isLayoutHorizontal,
    items = _ref.items,
    id = _ref.id,
    radioButtonOptions = _ref.radioButtonOptions,
    selectedItem = _ref.selectedItem,
    defaultValue = _ref.defaultValue,
    selectedValue = _ref.selectedValue,
    props = _objectWithoutProperties(_ref, _excluded);
  var getItemFromValue = function getItemFromValue(value) {
    if (value === undefined || value === null) {
      return null;
    }
    return items.filter(function (i) {
      return (0, _utils.getComponentItemValue)(i) == value;
    })[0];
  };
  var propertyClasses = [];
  var _useState = (0, _react.useState)(getItemFromValue(defaultValue) || getItemFromValue(selectedValue) || selectedItem),
    _useState2 = _slicedToArray(_useState, 2),
    currentSelectedItem = _useState2[0],
    setCurrentSelectedItem = _useState2[1];
  (0, _react.useEffect)(function () {
    if (selectedItem) {
      setCurrentSelectedItem(selectedItem);
    }
    //eslint-disable-next-line
  }, [selectedItem]);
  (0, _react.useEffect)(function () {
    if (selectedValue) {
      setCurrentSelectedItem(getItemFromValue(selectedValue));
    }
    //eslint-disable-next-line
  }, [selectedValue]);
  propertyClasses.push(disabled ? 'disabled' : '');
  propertyClasses.push(isLayoutHorizontal ? "horizontal" : "vertical");
  return /*#__PURE__*/_react["default"].createElement(_RadioButtonGroup.RadioButtonGroupStyles, _extends({}, props, {
    className: propertyClasses.join(' ')
  }), (items || radioButtonOptions).map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_RadioButton["default"], {
      id: "".concat(id, "-radio-").concat(item.value !== undefined ? item.value : item),
      key: "".concat(id, "-radio-").concat(item.value !== undefined ? item.value : item),
      name: id,
      automationId: automationId || "".concat(id, "-radio-").concat((0, _utils.getComponentItemValue)(item)),
      disabled: disabled,
      label: item.text || item.label || item,
      value: (0, _utils.getComponentItemValue)(item),
      checked: (0, _utils.componentItemsEqual)(currentSelectedItem, item),
      className: (0, _utils.componentItemsEqual)(currentSelectedItem, item) ? "selected" : "",
      onChange: function onChange(e) {
        if (e.target.checked) {
          // this is to make sure onChange on gets called once rather than the radio button just checked and the one unchecked
          var newSelectedItem = getItemFromValue(e.target.value);
          setCurrentSelectedItem(newSelectedItem);
          if (handleChange) {
            handleChange(e);
          } else if (_onChange) {
            //onChange will pass the value that was just selected back to the radio button
            _onChange(newSelectedItem);
          }
        }
      },
      ref: ref
    });
  }));
});
RadioButtonGroup.defaultProps = {
  disabled: false,
  automationId: '',
  onChange: null,
  isLayoutHorizontal: false,
  items: [],
  id: '',
  defaultItem: null,
  selectedItem: null,
  defaultValue: '',
  selectedValue: ''
};
RadioButtonGroup.propTypes = {
  disabled: _propTypes["default"].bool,
  automationId: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  isLayoutHorizontal: _propTypes["default"].bool,
  items: _propTypes["default"].array,
  id: _propTypes["default"].string,
  defaultItem: _propTypes["default"].any,
  selectedItem: _propTypes["default"].any,
  defaultValue: _propTypes["default"].string,
  selectedValue: _propTypes["default"].any,
  handleChange: _propTypes["default"].func,
  radioButtonOptions: _propTypes["default"].array
};
var _default = exports["default"] = RadioButtonGroup;